export default __webpack_public_path__ + "static/media/GasSensorImg.6b040ca7.jpg";